import { sendEmailVerification } from 'firebase/auth';
import { emailVerificationSettings } from '../utils/needsEmailVerification.ts';
import { getAuth } from '../getAuth.ts';
import _d from '@repperjs/debug';

/* eslint-disable no-unused-vars */
const log = _d('repper:services:firebase:user'),
    error = _d('repper:error'),
    warn = _d('repper:warning');
/* eslint-enable no-unused-vars */

export const getCurrentUser = () => getAuth().currentUser;
export const getCurrentUserId = () => getAuth().currentUser?.uid;

export const sendVerifyEmail = async () => {
    try {
        const user = getCurrentUser();
        if (!user) {
            throw new Error('User not found');
        }
        // @NOTE: the settings are not typed correctly in the firebase SDK
        // @ts-ignore
        const verifyResult = await sendEmailVerification(user, emailVerificationSettings);
        log('verifyResult', verifyResult);
        return verifyResult;
    } catch (e) {
        error('Sending verification email failed', e);
    }
};

export const logout = async () => {
    return await getAuth().signOut();
};
